import { Component, Prop, Vue } from 'vue-property-decorator';
import { ContainerForm } from '@/components';
import { CreateElement, VNode } from 'vue';
import { Title } from '@/components';
import './styles.styl';

@Component({
  name: 'MessageBox',
})
export default class MessageBox extends Vue {
  @Prop({type: String, default: ''}) public readonly text!: string;
  @Prop({type: String, default: ''}) public readonly title!: string;
  @Prop({type: String, default: ''}) public readonly link!: string;
  @Prop({type: String, default: ''}) public readonly buttonText!: string;

  private render(createElement: CreateElement): VNode {

    const title: VNode | false = !!this.title && createElement(Title, {
      props: {
        tag: 'h3',
        text: this.title,
      },
    });

    const text: VNode = createElement('p', {
      class: 'message-text',
    },  this.text);

    const button: VNode | false = !!this.link && createElement('router-link', {
      props: {
        to: this.link,
      },
      class: 'orange-big-button',
    }, this.buttonText);

    return createElement(ContainerForm, [
      this.$slots.title || title,
      this.$slots.text || text,
      this.$slots.button || button,
    ]);
  }
}
